'use client';
import styled, { css } from 'styled-components';
import Col from 'antd/es/col';

export const StyledGrid = styled.div`
  width: 100%;
  margin: 80px 0;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 40px;
  }
`;

export const Wrapper = styled.div`
  flex-grow: 1;
  margin-top: 40px;
`;

export const CampaignsScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  padding-top: 40px;
`;

export const StyledCol = styled(Col)<{ index: number }>`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const CampainListContainer = styled.div<{
  isShowAll: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  justify-items: center;

  ${({ isShowAll = false }) =>
    !isShowAll &&
    css`
      & > *:nth-child(n + 5) {
        display: none;
      }
    `}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
